export default __webpack_public_path__ + "static/media/add-icon.5946da9d.svg";